import { render } from "./BaseBadge.vue?vue&type=template&id=4d7e2048&scoped=true"
const script = {}

import "./BaseBadge.vue?vue&type=style&index=0&id=4d7e2048&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7e2048"]])

export default __exports__